<template>
    <section id="locationsSummary" class="row">
        <div id="mapContainer" class="col-lg-4 col-sm-6 hidden-xs">
            <google-map :mapSettings="mapSettings" :locations="locations" :clusterer="clusterer" :t="t"></google-map>
        </div>
        <div class="page-layout col-lg-8 col-sm-6 row">
            <div class="card-holder-sm">
                <div :class="wrapperClasses" v-for="location in locations" :key="location.id">
                    <div class="card-alpha">
                        <a :href="location.url" :title="t.view.replace('%location', location.name)">
                            <div class="card-block-panel-sm" v-bind:class="{ 'one-liner': !showCountsOnList }">
                                <p>
                                    {{ location.name }}
                                    <template v-if="showCountsOnList">
                                        <br />
                                        <small>{{ t.count.replace('%count', location[mapSettings.localeKey]) }}</small>
                                    </template>
                                </p>
                            </div>
                            <div class="card-side-panel-sm hidden-xs">
                                <i class="fa fa-map-marker"></i>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'Site/scss/card.scss';
import GoogleMap from './GoogleMap.vue';

export default {
    name: 'MapAndList',
    components: {
        GoogleMap
    },
    computed: {
        wrapperClasses() {
            if (this.locations.length > 28) {
                return 'filter-item col-lg-3 col-md-6 col-sm-6';
            }
            return 'filter-item col-lg-4 col-md-6 col-sm-6';
        }
    },
    props: {
        clusterer: {
            type: Boolean,
            default: true
        },
        mapSettings: {
            type: Object,
            required: true
        },
        locations: {
            type: Array,
            required: true
        },
        t: {
            type: Object,
            required: true
        },
        showCountsOnList: {
            type: Boolean,
            default: true
        }
    }
};

</script>

<style lang="scss">
#locationsSummary {
    height: 480px;
}
</style>
